module.exports = __webpack_public_path__ + "static/media/logo_text_white.b0725e09.png";